import React, { Component } from "react";
import AppModalBs from "../../partials/AppModalBs";
import AppInput from "../../partials/AppInput";

export class CareerEditModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      role: "",
      job_description: "",
      skills_required: "",
      experience_required: "",
      location: "",
      number_of_positions: 1,
      status: "Active",
    };
  }

  componentDidMount() {
    if (this.props.editdata) {
      this.populateData(this.props.editdata);
    }
  }

  componentDidUpdate(prevProps) {
    if (
      this.props.modalKey !== prevProps.modalKey ||
      this.props.editdata !== prevProps.editdata
    ) {
      if (this.props.editdata) {
        this.populateData(this.props.editdata);
      }
    }
  }

  populateData = (data) => {
    const skillsStr = Array.isArray(data.skillsRequired)
      ? data.skillsRequired.join("\n")
      : (data.skills_required || data.skillsRequired || data.skills || "");
    const expStr = Array.isArray(data.experienceRequired)
      ? data.experienceRequired.join("\n")
      : (data.experience_required || data.experienceRequired || data.experience || "");

    this.setState({
      role: data.jobRole || data.role || data.title || "",
      job_description: data.description || data.job_description || "",
      skills_required: skillsStr,
      experience_required: expStr,
      location: data.location || "",
      number_of_positions: data.numberOfPositions || data.number_of_positions || 1,
      status: data.status || data.state || (data.isActive !== undefined ? (data.isActive ? "Active" : "Deactivated") : "Active"),
    });
  };

  handleSubmit = (e) => {
    e.preventDefault();
    if (this.props.onSubmit) {
      this.props.onSubmit(e, this.state);
    }
  };

  render() {
    let { id, title = "Edit Job Details", onClose, submitText = "Save", viewMode, roles = [], locations = [], experience = [] } = this.props;
    const { role, job_description, skills_required, experience_required, location, number_of_positions, status } = this.state;

    return (
      <AppModalBs id={id} title={title} onClose={onClose} size="modal-lg">
        <form onSubmit={this.handleSubmit} key={this.props.modalKey || 'career-edit-modal'}>
          <div className="px-4 py-3">
            {/* Role Field */}
            <div className="mb-3">
              <AppInput
                type="text"
                label="Role"
                name="role"
                required={true}
                labelClass="form-label fw-bold text-dark mb-1"
                controlClass="shadow-none border"
                placeholder="Please enter role"
                defaultValue={role}
                disabled={viewMode}
                onChange={(e) => this.setState({ role: e.target.value })}
              />
            </div>

            {/* Job description Field */}
            <div className="mb-3">
              <AppInput
                type="textarea"
                label="Job description"
                name="job_description"
                required={true}
                labelClass="form-label fw-bold text-dark mb-1"
                controlClass="shadow-none border"
                placeholder="Please enter"
                rows={3}
                defaultValue={job_description}
                disabled={viewMode}
                onChange={(e) => this.setState({ job_description: e.target.value })}
              />
            </div>

            {/* Skills Required Field */}
            <div className="mb-3">
              <AppInput
                type="textarea"
                label="Skills Required"
                name="skills_required"
                required={true}
                labelClass="form-label fw-bold text-dark mb-1"
                controlClass="shadow-none border"
                placeholder="Please enter (one per line)"
                rows={2}
                defaultValue={skills_required}
                disabled={viewMode}
                onChange={(e) => this.setState({ skills_required: e.target.value })}
              />
            </div>

            {/* Experience Required Field */}
            <div className="mb-3">
              <AppInput
                type="textarea"
                label="Experience Required"
                name="experience_required"
                required={true}
                labelClass="form-label fw-bold text-dark mb-1"
                controlClass="shadow-none border"
                placeholder="Please enter (one per line)"
                rows={2}
                defaultValue={experience_required}
                disabled={viewMode}
                onChange={(e) => this.setState({ experience_required: e.target.value })}
              />
            </div>

            {/* Location Field */}
            <div className="mb-3">
              <AppInput
                type="textarea"
                label="Location"
                name="location"
                required={true}
                labelClass="form-label fw-bold text-dark mb-1"
                controlClass="shadow-none border"
                placeholder="Please enter (one per line)"
                rows={2}
                defaultValue={location}
                disabled={viewMode}
                onChange={(e) => this.setState({ location: e.target.value })}
              />
            </div>
            
            {/* Status Field */}
            <div className="mb-3">
              <AppInput
                type="select"
                label="Status"
                name="status"
                required={true}
                labelClass="form-label fw-bold text-dark mb-1"
                controlClass="shadow-none border"
                defaultValue={status}
                disabled={viewMode}
                onChange={(data) => {
                  let val = Array.isArray(data) && data.length > 0 ? data[0].key : "";
                  this.setState({ status: val });
                }}
                options={[
                  { key: "", label: "Please select" },
                  { key: "Active", label: "Active" },
                  { key: "Deactivated", label: "Deactivated" },
                ]}
              />
            </div>
          </div>

          <div className="d-flex justify-content-end p-3 px-4 bg-white" style={{ borderBottomLeftRadius: '12px', borderBottomRightRadius: '12px' }}>
            <button
              type="button"
              className="btn border-0 px-4 me-3 text-secondary fw-semibold"
              data-bs-dismiss="modal"
              onClick={onClose}
              style={{ borderRadius: '8px', backgroundColor: '#e9ecef', color: '#495057' }}
            >
              Cancel
            </button>
            {!viewMode && (
              <button
                type="submit"
                className="btn text-white px-4 fw-bold"
                style={{ backgroundColor: '#ff9800', borderColor: '#ff9800', borderRadius: '8px' }}
              >
                {submitText}
              </button>
            )}
          </div>
        </form>
      </AppModalBs>
    );
  }
}

export default CareerEditModal;
